@let isMainLoading = loading();
@let isActiveTabLoading = activeTabLoading();
@let showLoading = isMainLoading || isActiveTabLoading;
@let isNoDataError = !selectedData() && initialized();

<div class="relative h-full w-full flex flex-col" [class.overflow-hidden]="showLoading">
  @let activeTabChartFullscreenActivated = activeTabIsChartFullscreen();
  @if (!activeTabChartFullscreenActivated && !isNoDataError) {
    <div class="flex items-center shrink-0 justify-between w-full px-[0.75rem] sm:px-[1rem] gap-2 overflow-x-auto pb-[0.75rem]">
      @let allTabs = tabs();

      @if (allTabs) {
        <gc-floating-popup-tabs class="min-w-0 flex-1" [facade]="allTabs"></gc-floating-popup-tabs>
      } @else {
        <div class="flex-1"></div>
      }

      <div class="flex items-center gap-1">
        <p-button
          [text]="true"
          severity="contrast"
          styleClass="!h-7 !px-1.5 !py-1
            shrink-0
            !gap-[0.25rem]
            !text-(--p-primary-500)
            hover:!bg-(--p-neutral-500)
            hover:!border-[1px]
            hover:!border-(--p-primary-100)"
          [pTooltip]="'@@shared-report__label' | translate"
          tooltipPosition="bottom"
          tooltipStyleClass="text-[0.75rem] !z-app-overlay-0"
          (onClick)="openReport()"
          >
          <svg-icon class="!size-[1.25rem] !text-(--p-primary-500)" src="icons/icon-print.svg" name="icon-print"></svg-icon>
          @if (scrRes.isScreenMdUp()) {
            <span class="!text-(--p-primary-500) text-[0.6875rem] font-medium leading-4 ml-1">{{ '@@shared-report__label' | translate }}</span>
          }
        </p-button>
      </div>
    </div>
  }

  @if (isNoDataError) {
    <div class="grow-1 items-center justify-center min-h-[6.25rem] flex flex-col px-[0.75rem] sm:px-[1rem]">
      <gc-floating-popup-base-error-message></gc-floating-popup-base-error-message>
    </div>
  } @else {
    @let tabConnectService = activeTabConnectService();

    @if (tabConnectService) {
      <ng-container *ngComponentOutlet="tabConnectService.component; inputs: { popup: popup() }"></ng-container>
    } @else {
      <div class="flex items-center justify-center flex-1 w-full px-5 relative text-(--p-gray-500)">
        This is not implemented yet! Logger Measurement ID: {{data.measurement?.id ?? 'no measurement'}}<br>
        Selected tab key: {{selectedTab()}}<br>
        Need to add content in future for this tab
      </div>
    }
  }

  @if (showLoading) {
    <div class="absolute inset-0 z-content-overlay-20">
      <gc-spinner></gc-spinner>
    </div>
  }
</div>
